<style scoped lang="scss">
    @import "../../styles/var";

    ul {
        li + li {
            margin-top: -1px;
        }

        .cover {
            border: 1px solid $mainColor;
        }

        .cover + li {
            border-top: 1px solid $mainColor;
        }
    }
</style>
<template>
    <div class="list">
        <el-collapse accordion v-model="active">
            <el-collapse-item name="1">
                <template slot="title">
                    <div class="fs14 pl15">待分诊(23)</div>
                </template>
                <ul>
                    <li class="pl15 pr15 pt15 pb15 bt bb" v-for="(o,i) in 3">
                        <div class="flex color_333 fs14">
                            <span class="flex0">李俊基</span>
                            <span class="flex0 ml5">男</span>
                            <span class="flex1 ml5">23岁</span>
                            <span class="flex0">待分诊</span>
                        </div>
                        <div class="ellipsis fs12 color_999">
                            医生医生，我有个问题想咨询你一下，XXXXXXXXXXXXXXXX
                        </div>
                        <div class="flex mt5 jce">
                            <el-button size="mini">分诊</el-button>
                            <el-button size="mini" type="primary">结束分诊</el-button>
                        </div>
                    </li>
                </ul>
            </el-collapse-item>
            <el-collapse-item name="2">
                <template slot="title">
                    <div class="fs14 pl15">分诊中(13)</div>
                </template>
                <ol class="bt pl15 pr15">
                    <li class="pt15 pb15" :class="{bt:i>0}" :key="i" v-for="(o,i) in 3">
                        <div class="flex color_333 fs14">
                            <span class="flex0">李俊基</span>
                            <span class="flex0 ml5">男</span>
                            <span class="flex1 ml5">23岁</span>
                            <span class="flex0">进行中</span>
                        </div>
                        <div class="ellipsis fs12 color_999">
                            医生医生，我有个问题想咨询你一下，XXXXXXXXXXXXXXXX
                        </div>
                        <div class="fs12 color_333 ellipsis">
                            评价：分诊人员很负责，讲解的很详细,xxxxxxxxxxxxxxxxxxxx
                        </div>
                    </li>
                </ol>
            </el-collapse-item>
            <el-collapse-item name="3">
                <template slot="title">
                    <div class="fs14 pl15">已结束(13)</div>
                </template>
                <ol class="bt pl15 pr15">
                    <li class="pt15 pb15" :class="{bt:i>0}" :key="i" v-for="(o,i) in 3">
                        <div class="flex color_333 fs14">
                            <span class="flex0">李俊基</span>
                            <span class="flex0 ml5">男</span>
                            <span class="flex1 ml5">23岁</span>
                            <span class="flex0 color_red">已结束</span>
                        </div>
                        <div class="ellipsis fs12 color_999">
                            医生医生，我有个问题想咨询你一下，XXXXXXXXXXXXXXXX
                        </div>
                        <div class="fs12 color_333 ellipsis">
                            评价：分诊人员很负责，讲解的很详细,xxxxxxxxxxxxxxxxxxxx
                        </div>
                    </li>
                </ol>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>

  export default {
    name: "gp-list",
    components: {},
    props: {
      list: Array,
    },
    data() {
      return {
        height: 0,
        active: '1'
      }
    },
    computed: {},
    created() {
    },
    methods: {}
  }
</script>
